
<div style="width:400px;">
  <div style="width:99%;">
  <span> <button class="btn btn border" (click)="saveInstitutionGroup()" [disabled]="!form.dirty">Spara</button>  <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br><hr />
 <form [formGroup]="form">

  <!--div class="row">
 <div class="col-md-2">
   <label>
     Id
   </label>
   <input id="id" type="text" class="form-control form-control-sm" formControlName="id"
     readonly>
   </div>
  </div-->

  <div class="row">
   <div class="col-md-8">
     <label>
       Namn
     </label>
     <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
   </div>
  </div>

<div class="row">
   <div class="col-md-10">
     <label>
       Beskrivning
     </label>
     <input id="description" type="text" class="form-control form-control-sm" formControlName="description">
   </div>
  </div>

  <div class="row">
   <div class="col-md-4">
    <!--label>
      Primary
    </label>
    <input id="primary" type="text" class="form-control form-control-sm" formControlName="primary"-->
    <mat-checkbox id="primary" formControlName="primary">Primary</mat-checkbox>
  </div>
</div>

<div class="row">
  <div class="col-md-4">
    <!--label>
      Managed
    </label>
    <input id="managed" type="text" class="form-control form-control-sm" formControlName="managed"-->
    <mat-checkbox id="managed" formControlName="managed">Managed</mat-checkbox>

  </div>
</div>


<div class="row">
  <div class="col-md-4">
    <!--label>
      Terminal
    </label>
    <input id="terminal" type="text" class="form-control form-control-sm" formControlName="terminal"-->
    <mat-checkbox #cb id="terminal" formControlName="terminal">Terminal</mat-checkbox>

  </div>

</div>


   </form>
   </div>
 </div>




